import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import {
  api_cycle_timeline_stats,
  api_cycle_reviewed_users,
} from '../../constants/apiRoutes';
import { CYCLE_DETAILS_DEFAULT_PARAMS } from '../../constants/pages';
import { isObjectEmpty } from '../../utility/helpers';
import { parseDuplicateParameters } from '../../utility/uiUtils';

// ------------------------------------
// Constants
// ------------------------------------

const SET_CYCLE_STATS = 'SET_CYCLE_STATS';
const SET_CYCLE_EMPLOYEES = 'SET_CYCLE_EMPLOYEES';
const LOAD_MORE_CYCLE_EMPLOYEES = 'LOAD_MORE_CYCLE_EMPLOYEES';
const CLEAR_CYCLE = 'CLEAR_CYCLE';

const initialState = {
  stats: {},
  employees: {},
};

// ------------------------------------
// Actions
// ------------------------------------

const setCycleStats = createAction(SET_CYCLE_STATS);
const setCycleEmployees = createAction(SET_CYCLE_EMPLOYEES);
const loadMoreCycleEmployees = createAction(LOAD_MORE_CYCLE_EMPLOYEES);
const setClearCycle = createAction(CLEAR_CYCLE);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_CYCLE_STATS]: (state, { payload }) => {
    return { ...state, stats: { ...payload } };
  },
  [SET_CYCLE_EMPLOYEES]: (state, { payload }) => {
    return { ...state, employees: { ...payload } };
  },
  [LOAD_MORE_CYCLE_EMPLOYEES]: (state, { payload }) => {
    return isObjectEmpty(payload)
      ? { ...state, employees: payload }
      : {
          ...state,
          employees: {
            ...payload,
            results: state.employees.results
              ? [...state.employees.results, ...payload.results]
              : [...payload.results],
          },
        };
  },
  [CLEAR_CYCLE]: () => {
    return { ...initialState };
  },
};

export const getCycleTimelineStats = (dispatch, cycleId) => {
  return http.get(api_cycle_timeline_stats(cycleId)).then(({ data }) => {
    dispatch(setCycleStats(data));
  });
};

export const getCycleEmployees = (
  dispatch,
  cycleId,
  params = {},
  isLoadMore = false
) => {
  return http
    .get(api_cycle_reviewed_users(cycleId), {
      params: {
        ...CYCLE_DETAILS_DEFAULT_PARAMS,
        ...params,
      },
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      dispatch(
        isLoadMore ? loadMoreCycleEmployees(data) : setCycleEmployees(data)
      );
    });
};

export const clearCycle = () => setClearCycle();

export default handleActions(reducers, initialState);
